import React from 'react';
import { ArrowRight } from 'lucide-react';
import { destinations } from '../data/site';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function Discover() {
  return <section id="taveuni" className="w-full bg-ivory py-24 sm:py-28 lg:py-36" data-id="element-38" data-mp="3dpai1svo8vaa">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12" data-id="element-39" data-mp="3inc7qwnlrsuq">
        <Reveal className="max-w-3xl" data-id="element-40" data-mp="3ilhkvcsrtqo0">
          <SectionLabel data-id="element-41" data-mp="a7itypknovhd">The Island</SectionLabel>
          <h2 className="mt-6 font-serif text-[clamp(2rem,4.5vw,3.5rem)] font-light leading-[1.08] text-forest-deep" data-id="element-42" data-mp="a5pld4qhg16q">
            Discover Taveuni
          </h2>
          <p className="mt-4 font-serif text-2xl italic text-ocean" data-id="element-43" data-mp="8kxn0gznxnt">
            The Garden Island of Fiji.
          </p>
          <p className="mt-6 text-[16px] leading-[1.85] text-forest-deep/65" data-id="element-44" data-mp="574kr47bjfhr">
            From lush rainforests and waterfalls to beautiful coastlines and
            world-class diving, Taveuni offers a unique combination of adventure,
            nature, and island life.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:mt-20 lg:grid-cols-6" data-id="element-45" data-mp="1j3t45een6vca">
          {destinations.map((destination, i) => <Reveal as="li" key={destination.title} delay={i * 0.07} className={i < 2 ? 'lg:col-span-3' : 'lg:col-span-2'} data-id="element-46" data-mp="1s47r0i798ihw" data-mpi={i}>
              <article className="group relative h-full overflow-hidden rounded-[1.75rem] bg-forest-deep" data-id="element-47" data-mp="222f60vhzgqh9">
                <img src={destination.image} alt={destination.alt} loading="lazy" className={`w-full object-cover opacity-90 transition-all duration-[1200ms] ease-calm group-hover:scale-[1.06] group-hover:opacity-100 ${i < 2 ? 'h-[380px] lg:h-[440px]' : 'h-[340px] lg:h-[400px]'}`} data-id="element-48" data-mp="1x3kbwxekffhu" />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/90 via-forest-deep/25 to-transparent" data-id="element-49" data-mp="2fubsaiwz065q" />
                <div className="absolute inset-x-0 bottom-0 p-7" data-id="element-50" data-mp="1dhfd2vnf4k2s">
                  <h3 className="text-[12px] font-semibold uppercase tracking-[0.18em] text-ivory" data-id="element-51" data-mp="1hhpowoxw64pk">
                    {destination.title}
                  </h3>
                  <p className="mt-2.5 max-w-sm text-[14px] leading-relaxed text-ivory/75" data-id="element-52" data-mp="1mezcs05mu8ba">
                    {destination.description}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold-soft" data-id="element-53" data-mp="1w5u077um7dyb">
                    Explore
                    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 ease-calm group-hover:translate-x-1.5" aria-hidden="true" data-id="element-54" data-mp="257tie3hd8o2u" />
                  </span>
                </div>
                <a href="#book" className="absolute inset-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label={`Explore ${destination.title}`} data-id="element-55" data-mp="avdg1droxu39" />
              </article>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}